import { render } from "./AlgoCard.vue?vue&type=template&id=70cb2590&scoped=true"
import script from "./AlgoCard.vue?vue&type=script&lang=js"
export * from "./AlgoCard.vue?vue&type=script&lang=js"

import "./AlgoCard.vue?vue&type=style&index=0&id=70cb2590&scoped=true&lang=css"

import exportComponent from "/Users/walt/WORK/school/portfolio/s1-crypto-prng/prng/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70cb2590"]])

export default __exports__